var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9556 6.43678L9.05063 20.0424L3.04199 14.0338L4.5004 12.5754L8.95017 17.0252L19.4034 5.07861L20.9556 6.43678Z",
    fill: "#56EE99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesCheckIcon);
export default __webpack_public_path__ + "static/media/featuresCheckIcon.af1d50ab507eccbbfb3402c3eb7b5bad.svg";
export { ForwardRef as ReactComponent };